// Textos de Férias (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.ferias.limiteDpCurto': 'DP',
    'dp.ferias.vencimentoLegalCurto': 'CLT',
    'dp.ferias.diasVencidos': '{{n}} vencidos',
    'dp.ferias.diasPagos': '{{n}} pagos',
    'dp.ferias.diasProporcionais': '{{n}} proporcionais',
    'dp.ferias.kpi.em_ferias': 'Em férias hoje',
    'dp.ferias.kpi.inicio_15': 'Começam em {{feriasInicioDias}} dias',
    'dp.ferias.kpi.pagamento_7': 'Pagar em {{feriasPagamentoDias}} dias',
    'dp.ferias.kpi.sem_programacao_60': 'Perto do limite',
    'dp.ferias.kpi.vencidas': 'Vencidas',
    'dp.ferias.kpi.fora_da_clt': 'Fora da CLT',
    'dp.ferias.kpiDica.sem_programacao_60': 'Sem programação, com a data limite do DP em até {{feriasLimiteDias}} dias',
    'dp.ferias.kpiDica.vencidas': 'Passaram do vencimento legal e são pagas em dobro',
    'dp.ferias.kpiDica.fora_da_clt': 'Programação fora da divisão da CLT: até três períodos, um com {{feriasMaiorDias}} dias ou mais e os outros com {{feriasMenorDias}} ou mais',
    'dp.ferias.titulo': 'Férias',
    'dp.ferias.explica': 'A tela só lê: quem programa e paga as férias é o Protheus. O pagamento é até {{feriasPagamentoUteis}} dias úteis antes do início, e depois do vencimento legal as férias são em dobro.',
    'dp.ferias.semProgramacao': 'Sem programação',
    'dp.ferias.periodo': '{{inicio}} a {{fim}}, {{dias}} dias',
    'dp.ferias.pagamento': 'Pagamento',
    'dp.ferias.limiteDp': 'Limite do DP',
    'dp.ferias.vencimentoLegal': 'Vencimento legal',
    'dp.ferias.foraDaClt': 'Fora da CLT: {{motivo}}',
    'dp.ferias.de': 'De {{data}}',
    'dp.ferias.ate': 'Até {{data}}',
    'dp.ferias.col.aquisitivo': 'Período aquisitivo',
    'dp.ferias.col.programacao': 'Programação',
    'dp.ferias.col.prazos': 'Prazos',
    'dp.ferias.alerta.em_ferias': 'Em férias hoje',
    'dp.ferias.alerta.inicio_15': 'Começam em {{feriasInicioDias}} dias',
    'dp.ferias.alerta.pagamento_7': 'Pagar em {{feriasPagamentoDias}} dias',
    'dp.ferias.alerta.sem_programacao_60': 'Sem programação perto do limite',
    'dp.ferias.alerta.vencidas': 'Vencidas, em dobro',
    'dp.ferias.alerta.fora_da_clt': 'Fora da CLT',
    'dp.ferias.validacao.sem_programacao': 'Sem programação',
    'dp.ferias.validacao.programada': 'Programada',
    'dp.ferias.validacao.paga': 'Programada e paga',
    'dp.ferias.importarTitulo': 'Importar a programação de férias',
    'dp.ferias.pagaEm': 'Paga em {{data}}',
    'dp.ferias.pagaComAtraso': 'Paga com atraso em {{data}}',
    'dp.ferias.importarExplica': 'A planilha de programação de férias do DP, aba Consulta1. Ela é o retrato inteiro dos períodos em aberto: o período que não vier mais sai da lista, porque foi pago ou prescrito.',
    'dp.ferias.carga.comProgramacao': 'Com programação',
    'dp.ferias.carga.vencidas': 'Com férias vencidas',
    'dp.ferias.carga.encerrados': 'Saem da lista',
    'dp.escolherPlanilha': 'Escolher a planilha',
  },
  en: {
    'dp.ferias.limiteDpCurto': 'HR',
    'dp.ferias.vencimentoLegalCurto': 'Law',
    'dp.ferias.diasVencidos': '{{n}} overdue',
    'dp.ferias.diasPagos': '{{n}} paid',
    'dp.ferias.diasProporcionais': '{{n}} proportional',
    'dp.ferias.kpi.em_ferias': 'On vacation today',
    'dp.ferias.kpi.inicio_15': 'Start in {{feriasInicioDias}} days',
    'dp.ferias.kpi.pagamento_7': 'Pay in {{feriasPagamentoDias}} days',
    'dp.ferias.kpi.sem_programacao_60': 'Near the deadline',
    'dp.ferias.kpi.vencidas': 'Overdue',
    'dp.ferias.kpi.fora_da_clt': 'Outside labor law',
    'dp.ferias.kpiDica.sem_programacao_60': 'Not scheduled, with the HR deadline within {{feriasLimiteDias}} days',
    'dp.ferias.kpiDica.vencidas': 'Past the legal deadline and paid double',
    'dp.ferias.kpiDica.fora_da_clt': 'Schedule outside the labor law split: up to three periods, one with {{feriasMaiorDias}} days or more and the others with {{feriasMenorDias}} or more',
    'dp.ferias.titulo': 'Vacations',
    'dp.ferias.explica': 'This screen only reads: Protheus schedules and pays vacations. Payment is due {{feriasPagamentoUteis}} business days before the start, and after the legal deadline vacations are paid double.',
    'dp.ferias.semProgramacao': 'Not scheduled',
    'dp.ferias.periodo': '{{inicio}} to {{fim}}, {{dias}} days',
    'dp.ferias.pagamento': 'Payment',
    'dp.ferias.limiteDp': 'HR deadline',
    'dp.ferias.vencimentoLegal': 'Legal deadline',
    'dp.ferias.foraDaClt': 'Against labor law: {{motivo}}',
    'dp.ferias.de': 'From {{data}}',
    'dp.ferias.ate': 'To {{data}}',
    'dp.ferias.col.aquisitivo': 'Accrual period',
    'dp.ferias.col.programacao': 'Schedule',
    'dp.ferias.col.prazos': 'Deadlines',
    'dp.ferias.alerta.em_ferias': 'On vacation today',
    'dp.ferias.alerta.inicio_15': 'Start within {{feriasInicioDias}} days',
    'dp.ferias.alerta.pagamento_7': 'Pay within {{feriasPagamentoDias}} days',
    'dp.ferias.alerta.sem_programacao_60': 'Unscheduled near the deadline',
    'dp.ferias.alerta.vencidas': 'Overdue, paid double',
    'dp.ferias.alerta.fora_da_clt': 'Against labor law',
    'dp.ferias.validacao.sem_programacao': 'Not scheduled',
    'dp.ferias.validacao.programada': 'Scheduled',
    'dp.ferias.validacao.paga': 'Scheduled and paid',
    'dp.ferias.importarTitulo': 'Import the vacation schedule',
    'dp.ferias.pagaEm': 'Paid on {{data}}',
    'dp.ferias.pagaComAtraso': 'Paid late on {{data}}',
    'dp.ferias.importarExplica': 'The HR vacation schedule spreadsheet, sheet Consulta1. It is the full picture of open periods: a period that no longer comes leaves the list, because it was paid or expired.',
    'dp.ferias.carga.comProgramacao': 'Scheduled',
    'dp.ferias.carga.vencidas': 'With overdue vacation',
    'dp.ferias.carga.encerrados': 'Leave the list',
    'dp.escolherPlanilha': 'Choose the spreadsheet',
  },
  es: {
    'dp.ferias.limiteDpCurto': 'DP',
    'dp.ferias.vencimentoLegalCurto': 'Ley',
    'dp.ferias.diasVencidos': '{{n}} vencidos',
    'dp.ferias.diasPagos': '{{n}} pagados',
    'dp.ferias.diasProporcionais': '{{n}} proporcionales',
    'dp.ferias.kpi.em_ferias': 'De vacaciones hoy',
    'dp.ferias.kpi.inicio_15': 'Empiezan en {{feriasInicioDias}} días',
    'dp.ferias.kpi.pagamento_7': 'Pagar en {{feriasPagamentoDias}} días',
    'dp.ferias.kpi.sem_programacao_60': 'Cerca del límite',
    'dp.ferias.kpi.vencidas': 'Vencidas',
    'dp.ferias.kpi.fora_da_clt': 'Fuera de la ley',
    'dp.ferias.kpiDica.sem_programacao_60': 'Sin programación, con la fecha límite del DP en hasta {{feriasLimiteDias}} días',
    'dp.ferias.kpiDica.vencidas': 'Pasaron del vencimiento legal y se pagan en doble',
    'dp.ferias.kpiDica.fora_da_clt': 'Programación fuera de la división de la ley laboral: hasta tres períodos, uno con {{feriasMaiorDias}} días o más y los otros con {{feriasMenorDias}} o más',
    'dp.ferias.titulo': 'Vacaciones',
    'dp.ferias.explica': 'La pantalla solo lee: quien programa y paga las vacaciones es el Protheus. El pago es hasta {{feriasPagamentoUteis}} días hábiles antes del inicio, y después del vencimiento legal las vacaciones son en doble.',
    'dp.ferias.semProgramacao': 'Sin programación',
    'dp.ferias.periodo': '{{inicio}} a {{fim}}, {{dias}} días',
    'dp.ferias.pagamento': 'Pago',
    'dp.ferias.limiteDp': 'Límite del DP',
    'dp.ferias.vencimentoLegal': 'Vencimiento legal',
    'dp.ferias.foraDaClt': 'Fuera de la ley laboral: {{motivo}}',
    'dp.ferias.de': 'Desde {{data}}',
    'dp.ferias.ate': 'Hasta {{data}}',
    'dp.ferias.col.aquisitivo': 'Período adquisitivo',
    'dp.ferias.col.programacao': 'Programación',
    'dp.ferias.col.prazos': 'Plazos',
    'dp.ferias.alerta.em_ferias': 'De vacaciones hoy',
    'dp.ferias.alerta.inicio_15': 'Empiezan en {{feriasInicioDias}} días',
    'dp.ferias.alerta.pagamento_7': 'Pagar en {{feriasPagamentoDias}} días',
    'dp.ferias.alerta.sem_programacao_60': 'Sin programación cerca del límite',
    'dp.ferias.alerta.vencidas': 'Vencidas, en doble',
    'dp.ferias.alerta.fora_da_clt': 'Fuera de la ley laboral',
    'dp.ferias.validacao.sem_programacao': 'Sin programación',
    'dp.ferias.validacao.programada': 'Programada',
    'dp.ferias.validacao.paga': 'Programada y pagada',
    'dp.ferias.importarTitulo': 'Importar la programación de vacaciones',
    'dp.ferias.pagaEm': 'Pagada el {{data}}',
    'dp.ferias.pagaComAtraso': 'Pagada con atraso el {{data}}',
    'dp.ferias.importarExplica': 'La planilla de programación de vacaciones del DP, hoja Consulta1. Es el retrato completo de los períodos abiertos: el período que ya no viene sale de la lista, porque fue pagado o prescribió.',
    'dp.ferias.carga.comProgramacao': 'Con programación',
    'dp.ferias.carga.vencidas': 'Con vacaciones vencidas',
    'dp.ferias.carga.encerrados': 'Salen de la lista',
    'dp.escolherPlanilha': 'Elegir la planilla',
  },
}
